import React from 'react';
import WhyAreWe from '../../components/About/WhyAreWe';
import image1 from '../../assets/images/resources/why-are-we-img-1.jpg';
import image2 from '../../assets/images/resources/why-are-we-img-2.jpg';

const WhyAreWeSec = () => {

    const points = [
        {
            iconClass: 'why-are-we__icon',
            arrowIcon: 'icon-arrow-down-left',
            icon: 'icon-location why-are-we__location',
            heading: 'Advanced Studio & Production Setup',
            text: 'Work with professional film sets including chroma studio, podcast setup, photography studio, and modern editing suites.'
        },
        {
            iconClass: 'why-are-we__icon-2',
            arrowIcon: 'icon-arrow-down-right',
            icon: 'icon-shopping-cart why-are-we__cart',
            heading: 'Training + Real Production Experience',
            text: 'Learn acting, direction, cinematography, and more while working on live shoots, film projects, and real client productions.'
        },
        {
            iconClass: '',
            arrowIcon: '',
            icon: 'icon-call why-are-we__call',
            heading: 'Career & Production Opportunities',
            text: 'Get internship support, portfolio building, and opportunities to work in films, music videos, and digital content creation.'
        }
    ];

    return (
        <>
        <WhyAreWe
            imageSrc1={image1}
            imageSrc2={image2}
            tagline="Why Choose Sunrising Cinevision"
            title="Where Learning Meets Real Film Production"
            points={points}
            year="Since 2020"
            yearDescription="Sunrising Cinevision is a creative platform combining professional training and film production, helping individuals turn passion into real-world success."
        />
        </>
    );
}

export default WhyAreWeSec;